export const PHONE_NUMBER = /^\(\d{2}\) \d{5}-\d{4}$/;

export const UPPERCASE_LETTER = /[A-Z]/;

export const LOWERCASE_LETTER = /[a-z]/;

export const SPECIAL_CHARACTER = /[^A-Za-z0-9]/;

export const REGEX_FORMATTED_TAX_ID = /^(([0-9]{3}.[0-9]{3}.[0-9]{3}-[0-9]{2}))$/;

export const REGEX_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
